import { ToastNotification, ToastNotificationProps } from "flicket-ui";
import { toast, ToastOptions } from "react-toastify";

export const showToast = (
  msg: ToastNotificationProps["msg"],
  type?: ToastNotificationProps["type"],
  options?: ToastOptions
) => {
  toast(() => <ToastNotification msg={msg} type={type} />, options);
};
